import ScormDetail from './ScormDetail';

export default ScormDetail;
